import React from "react";

import "./sideDrawer.css";
import userImg from "../../../images/user.png";
import en from "../../../images/english.png";
import es from "../../../images/spanish.png";

const sideDrawer = (props) => {
  let drawerClasses = "side-drawer";
  if (props.show) {
    drawerClasses = "side-drawer open";
  }

  if (props.today_badge === "" || props.today_badge === undefined) props.today_badge = 0;
  if (props.tomorrow_badge === "" || props.tomorrow_badge === undefined) props.tomorrow_badge = 0;
  if (props.messages_badge === "" || props.messages_badge === undefined) props.messages_badge = 0;
  if (props.yesterday_badge === "" || props.yesterday_badge === undefined) props.yesterday_badge = 0;

  var language = localStorage.getItem("language");

  const menuItems = [
    { key: "home", icon: "home", label: language === "en" ? "Home" : "Inicio" },
    { key: "today", icon: "today", label: language === "en" ? "Today's Trips" : "Viajes de Hoy", badge: props.today_badge },
    { key: "yesterday", icon: "event_busy", label: language === "en" ? "Yesterday's Trips" : "Viajes de Ayer", badge: props.yesterday_badge },
    { key: "tomorrow", icon: "event_note", label: language === "en" ? "Tomorrow's Trips" : "Viajes de Mañana", badge: props.tomorrow_badge },
    { key: "settlements", icon: "list_alt", label: language === "en" ? "Trip History" : "Historial de Viajes" },
  ];

  return (
    <nav className={drawerClasses}>
      {/* Header */}
      <div className='side-drawer__header'>
        <img
          src={userImg}
          alt='User'
          className='side-drawer__avatar'
          data-column='profile'
          onClick={props.click}
        />
        <div className='side-drawer__user-info' data-column='profile' onClick={props.click}>
          <div className='side-drawer__user-name'>{localStorage.getItem("name")}</div>
          <div className='side-drawer__user-email'>{localStorage.getItem("email")}</div>
        </div>
        <button
          className='side-drawer__settings-btn'
          data-column='settings'
          onClick={props.click}
          aria-label="Settings"
        >
          <i className='material-icons' style={{ fontSize: 24 }}>settings</i>
        </button>
      </div>

      {/* Menu Items */}
      <ul className='side-drawer__menu'>
        {menuItems.map((item) => (
          <li key={item.key}>
            <div
              className={`side-drawer__item ${props.label === item.key ? 'side-drawer__item--active' : ''}`}
              data-column={item.key}
              onClick={props.click}
            >
              <i className='material-icons'>{item.icon}</i>
              <span className='side-drawer__item-label'>{item.label}</span>
              {item.badge > 0 && (
                <span className='side-drawer__badge'>{item.badge}</span>
              )}
            </div>
          </li>
        ))}
      </ul>

      {/* Footer */}
      <div className='side-drawer__footer'>
        <div
          className='side-drawer__item'
          data-column={language}
          onClick={props.click}
        >
          <img
            src={language === "en" ? es : en}
            alt=''
            className='side-drawer__lang-icon'
          />
          <span className='side-drawer__item-label'>
            {language === "en" ? "Cambiar a Español" : "Change to English"}
          </span>
        </div>

        <div
          className='side-drawer__item'
          data-column='logout'
          onClick={props.click}
          style={{ color: "var(--color-danger)" }}
        >
          <i className='material-icons' style={{ color: "var(--color-danger)" }}>logout</i>
          <span className='side-drawer__item-label'>
            {language === "en" ? "Logout" : "Salir"}
          </span>
        </div>
      </div>
    </nav>
  );
};

export default sideDrawer;
